import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/rootReducer';

import X from '../../../assets/icons/new_icon/x.svg';
import fileIcon from '../../../assets/icons/new_icon/FileIcon.svg';
import smallDel from '../../../assets/icons/new_icon/smallDel.svg';
import delIcon from '../../../assets/icons/new_icon/delete-2.svg';

import {
  uploadSavedAddress,
  uploadSavedContact,
  uploadSavedPackage,
} from '../../../api/privateApis';
interface Props {
  onClose: any;
  isContact?: boolean;
  isPackage?: boolean;
}
const ImportAddressModal = ({ onClose, isContact, isPackage }: Props) => {
  const { enqueueSnackbar } = useSnackbar();
  const userData = useSelector(
    (state: RootState) => state.mainAppData.userData
  );
  const [loading, setLoading] = useState(false);
  const [document, setDocument] = useState<any>(null);
  const [fileName, setFileName] = useState('');
  const [validating, setValidating] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  function handleImport() {
    setValidating(true);
    if (document && fileName !== '') {
      setLoading(true);
      let payload: any = {
        account_number: userData?.account_number,
        username: userData?.username,
        file: document,
      };
      if (isContact) {
        uploadSavedContact(payload)
          .then((response) => {
            if (!response?.data?.is_error) {
              enqueueSnackbar('Documant has been uploaded', {
                variant: 'success',
              });
              setLoading(false);
              onClose();
            }
          })
          .catch((e) => setLoading(false));
      } else if (isPackage) {
        payload.box_type = 'NORM_BOX';
        delete payload.username;
        uploadSavedPackage(payload)
          .then((response) => {
            if (!response?.data?.is_error) {
              enqueueSnackbar('Documant has been uploaded', {
                variant: 'success',
              });
              setLoading(false);
              onClose();
            }
          })
          .catch((e) => setLoading(false));
      } else {
        uploadSavedAddress(payload)
          .then((response) => {
            if (!response?.data?.is_error) {
              enqueueSnackbar('Documant has been uploaded', {
                variant: 'success',
              });
              setLoading(false);
              onClose();
            }
          })
          .catch((e) => setLoading(false));
      }
    }
  }

  const handleClose = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleFileChange = (e: any) => {
    const file = e.target.files && e.target.files[0];

    if (file) {
      setFileName(file.name);

      const reader = new FileReader();

      reader.onload = (event) => {
        if (event.target?.result) {
          // Using optional chaining here
          if (typeof event.target.result === 'string') {
            // Check if result is a string
            const base64String = event.target.result.split(',')[1]; // Split only if it's a string
            setDocument(base64String);
          } else {
            // Assume it's an ArrayBuffer
            const arrayBuffer = event.target.result as ArrayBuffer;
            const binaryString = new Uint8Array(arrayBuffer);
            const base64String = btoa(
              String.fromCharCode.apply(null, Array.from(binaryString))
            );
            setDocument(base64String);
          }
        }
      };

      // For image files, read as ArrayBuffer
      if (file.type.startsWith('image/')) {
        reader.readAsArrayBuffer(file);
      } else {
        reader.readAsDataURL(file);
      }

      // Start the upload process
      handleUpload();
    }
  };

  const handleUpload = () => {
    // Simulate upload progress
    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      setUploadProgress(progress);
      if (progress >= 100) {
        clearInterval(interval);
      }
    }, 1000);
  };

  const handleDelete = () => {
    setDocument('');
    setFileName('');
    setUploadProgress(0);
  };

  return (
    <div
      className='modal'
      id='address_modal'
      style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5) ' }}
      tabIndex={-1}
      aria-labelledby='address_modal_label'
      aria-hidden='true'
      onClick={handleClose}
    >
      {loading && (
        <div className='loader-container'>
          <div className='spinner'></div>
        </div>
      )}
      <div className='modal-dialog modal-md'>
        <div className='modal-content'>
          <div className='modal-header d-flex w-100 justify-content-between px-4 py-2'>
            <h3 className='newubbemodalheading  mb-0'>
              {' '}
              {isContact
                ? 'Contact Upload'
                : isPackage
                ? 'Package Upload'
                : 'Address Upload'}
            </h3>

            <img src={X} onClick={onClose} className='cursor_pointer' alt='' />
          </div>

          <div className='modal-body'>
            {!fileName && (
              <div
                className={`${
                  validating
                    ? 'upload-file-container error-border'
                    : ' upload-file-container '
                }`}
              >
                <div className='d-flex gap-1 align-items-center m-auto justify-content-center '>
                  <img style={{ width: '15px' }} src={fileIcon} alt='' />
                  <label
                    htmlFor='file'
                    className='custom-file-upload'
                    onChange={handleFileChange}
                  >
                    Choose File
                  </label>
                </div>

                <input
                  type='file'
                  id='file'
                  className='custom-file-upload d-none'
                  onChange={handleFileChange}
                  accept='.xlsx, .xls'
                />
              </div>
            )}
            {!fileName && validating && (
              <div className='error_text'>Please choose a file.</div>
            )}
            {fileName && (
              <div className='file-info'>
                <div className='d-flex justify-content-between '>
                  <div style={{ width: '100%' }}>
                    <div className='d-flex align-items-center gap-1'>
                      <img src={fileIcon} />{' '}
                      <span className='createdby'>{fileName}</span>
                    </div>
                    {uploadProgress < 100 ? (
                      <div className='progress-container'>
                        <div
                          className='progress-bar mb-0 ms-3 '
                          style={{ width: `${uploadProgress}%` }}
                        />
                        <div className='progress-text mt-2 ms-3 '>
                          {uploadProgress}%
                        </div>
                      </div>
                    ) : (
                      <>
                        <p
                          className='tooltip-text mb-0 ms-3 my-2'
                          style={{ color: '#00B998' }}
                        >
                          Uploaded
                        </p>
                      </>
                    )}{' '}
                  </div>
                  {uploadProgress < 100 ? (
                    <div
                      onClick={handleDelete}
                      className='d-flex justify-content-between align-items-baseline '
                    >
                      <img src={smallDel} />
                    </div>
                  ) : (
                    <div className='d-flex justify-content-between align-items-baseline   '>
                      <button className='delete-button' onClick={handleDelete}>
                        <img src={delIcon} />
                      </button>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
          <span
            className='px-3 text-start fs-6 text-dark'
            id='upload_message'
          ></span>
          <div className=' d-flex py-2  flex-column  justify-content-center '>
            <p
              className='btn m-auto  ubbe-blue-bg p-2 px-4 rounded-3 text-light'
              onClick={handleImport}
              style={{
                width: 'max-content',
                backgroundColor: '#251163',
                fontFamily: 'Lexend',
              }}
            >
              Upload
            </p>
            <u
              className='m-auto mt-2 d-flex justify-content-center labelText'
              style={{ cursor: 'pointer' }}
              onClick={onClose}
            >
              Close
            </u>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImportAddressModal;
